import type { FC } from 'react';
import { Box } from '../Box';

export type SwogoProps = {
  /** This represents the position of the swogo container on the page. */
  position: number;
};

/** This is DOM-Container for swogo content. */
export const SwogoContainer: FC<SwogoProps> = ({ position }) => (
  <Box id={`swogo-bundle-${position}`} className="swogo-box" />
);
